export default (value: string | null) => {
  if (!value) return "Value must not be empty"

  if (!Number.isInteger(Number(value))) {
    return "Reading value must be a whole number"
  }

  if (Number(value) <= 0) {
    return "Reading value must be a positive number"
  }

  return true
}
